import { MastersActions } from "../action-types/mastersActionTypes";

// Vessel Master Action

export const getVesselMasterList = (payload) => {
  return {
    type: MastersActions.GET_VESSEL_MASTER_LIST,
    payload,
  };
};

export const setVesselMasterList = (payload) => {
  return {
    type: MastersActions.SET_VESSEL_MASTER_LIST,
    payload,
  };
};

export const addVesselMastersList = (payload) => {
  return {
    type: MastersActions.ADD_VESSEL_MASTER,
    payload,
  };
};

export const updateVesselMastersList = (payload) => {
  return {
    type: MastersActions.UPDATE_VESSEL_MASTERS,
    payload,
  };
};

export const deleteVesselMastersList = (payload) => {
  return {
    type: MastersActions.DELETE_VESSEL_MASTERS,
    payload,
  };
};

export const setVesselMasterPagination = (payload) => {
  return {
    type: MastersActions.SET_VESSEL_MASTER_PAGINATION,
    payload,
  };
};

// Vessel Type Master Action

export const getVesselTypeMasterList = (payload) => {
  return {
    type: MastersActions.GET_VESSEL_TYPE_MASTERS_LIST,
    payload,
  };
};

export const setVesselTypeMasterList = (payload) => {
  return {
    type: MastersActions.SET_VESSEL_TYPE_MASTERS_LIST,
    payload,
  };
};

export const addVesselTypeMastersList = (payload) => {
  return {
    type: MastersActions.ADD_VESSEL_TYPE_MASTERS,
    payload,
  };
};

export const updateVesselTypeMastersList = (payload) => {
  return {
    type: MastersActions.UPDATE_VESSEL_TYPE_MASTERS,
    payload,
  };
};

export const deleteVesselTypeMastersList = (payload) => {
  return {
    type: MastersActions.DELETE_VESSEL_TYPE_MASTERS,
    payload,
  };
};

export const setVesselTypeMasterPagination = (payload) => {
  return {
    type: MastersActions.SET_VESSEL_TYPE_MASTER_PAGINATION,
    payload,
  };
};

// Checklist Master and Checklist Question Action

export const getChecklistMastersList = (payload) => {
  return {
    type: MastersActions.GET_CHECKLIST_MASTERS_LIST,
    payload,
  };
};

export const setChecklistMastersList = (payload) => {
  return {
    type: MastersActions.SET_CHECKLIST_MASTERS_LIST,
    payload,
  };
};

export const addChecklistMastersList = (payload) => {
  return {
    type: MastersActions.ADD_CHECKLIST_MASTERS,
    payload,
  };
};

export const updateChecklistMastersList = (payload) => {
  return {
    type: MastersActions.UPDATE_CHECKLIST_MASTERS,
    payload,
  };
};

export const deleteChecklistMastersList = (payload) => {
  return {
    type: MastersActions.DELETE_CHECKLIST_MASTERS,
    payload,
  };
};

export const getQuestionChecklistMastersList = (payload) => {
  return {
    type: MastersActions.GET_CHECKLIST_QUESTION_MASTERS_LIST,
    payload,
  };
};

export const setQuestionChecklistMastersList = (payload) => {
  return {
    type: MastersActions.SET_CHECKLIST_QUESTION_MASTERS_LIST,
    payload,
  };
};

export const addQuestionChecklistMastersList = (payload) => {
  return {
    type: MastersActions.ADD_CHECKLIST_QUESTION_MASTERS,
    payload,
  };
};

export const updateQuestionChecklistMastersList = (payload) => {
  return {
    type: MastersActions.UPDATE_CHECKLIST_QUESTION_MASTERS,
    payload,
  };
};

export const getAllQuestionChecklistMastersList = (payload) => {
  return {
    type: MastersActions.GET_ALL_CHECKLIST_QUESTION_MASTERS_LIST,
    payload,
  };
};

export const setAllQuestionChecklistMastersList = (payload) => {
  return {
    type: MastersActions.SET_ALL_CHECKLIST_QUESTION_MASTERS_LIST,
    payload,
  };
};

export const setChecklistMasterPagination = (payload) => {
  return {
    type: MastersActions.SET_CHECKLIST_MASTER_PAGINATION,
    payload,
  };
};

// Checklist Type Master Action

export const getChecklistTypeMastersList = (payload) => {
  return {
    type: MastersActions.GET_CHECKLIST_TYPE_MASTERS_LIST,
    payload,
  };
};

export const setChecklistTypeMastersList = (payload) => {
  return {
    type: MastersActions.SET_CHECKLIST_TYPE_MASTERS_LIST,
    payload,
  };
};

export const addChecklistTypeMastersList = (payload) => {
  return {
    type: MastersActions.ADD_CHECKLIST_TYPE_MASTERS,
    payload,
  };
};

export const deleteChecklistTypeMastersList = (payload) => {
  return {
    type: MastersActions.DELETE_CHECKLIST_TYPE_MASTERS,
    payload,
  };
};

export const updateChecklistTypeMastersList = (payload) => {
  return {
    type: MastersActions.UPDATE_CHECKLIST_TYPE_MASTERS,
    payload,
  };
};

export const setChecklistTypeMasterPagination = (payload) => {
  return {
    type: MastersActions.SET_CHECKLIST_TYPE_MASTER_PAGINATION,
    payload,
  };
};

// Role Master Action

export const getRoleMasterList = () => {
  return {
    type: MastersActions.GET_ROLE_MASTER_LIST,
  };
};

export const setRoleMasterList = (payload) => {
  return {
    type: MastersActions.SET_ROLE_MASTER_LIST,
    payload,
  };
};

export const addRoleMastersList = (payload) => {
  return {
    type: MastersActions.ADD_ROLE_MASTER,
    payload,
  };
};

export const deleteRoleMastersList = (payload) => {
  return {
    type: MastersActions.DELETE_ROLE_MASTER,
    payload,
  };
};

export const updateRoleMastersList = (payload) => {
  return {
    type: MastersActions.UPDATE_ROLE_MASTER,
    payload,
  };
};

// Screen Access Master Action

export const getScreenAccessMasterList = () => {
  return {
    type: MastersActions.GET_SCREEN_ACCESS_MASTER_LIST,
  };
};

export const setScreenAccessMasterList = (payload) => {
  return {
    type: MastersActions.SET_SCREEN_ACCESS_MASTER_LIST,
    payload,
  };
};

export const addScreenAccessMasterList = (payload) => {
  return {
    type: MastersActions.ADD_SCREEN_ACCESS_MASTER,
    payload,
  };
};

export const updateScreenAccessMasterList = (payload) => {
  return {
    type: MastersActions.UPDATE_SCREEN_ACCESS_MASTER,
    payload,
  };
};

export const deleteScreenAccessMastersList = (payload) => {
  return {
    type: MastersActions.DELETE_SCREEN_ACCESS_MASTER,
    payload,
  };
};

// Role Permission Master Action

export const getRolePermissionMasterList = (payload) => {
  return {
    type: MastersActions.GET_ROLE_PERMISSION_MASTER_LIST,
    payload,
  };
};

export const setRolePermissionMasterList = (payload) => {
  return {
    type: MastersActions.SET_ROLE_PERMISSION_MASTER_LIST,
    payload,
  };
};

export const addRolePermissionMasterList = (payload) => {
  return {
    type: MastersActions.ADD_ROLE_PERMISSION_MASTER,
    payload,
  };
};

export const deleteRolePermissionMasterList = (payload) => {
  return {
    type: MastersActions.DELETE_ROLE_PERMISSION_MASTER,
    payload,
  };
};

export const updateRolePermissionMasterList = (payload) => {
  return {
    type: MastersActions.UPDATE_ROLE_PERMISSION_MASTER,
    payload,
  };
};

// Company Action

export const getCompanyList = (payload) => {
  return {
    type: MastersActions.GET_COMPANY_LIST,
    payload,
  };
};

export const setCompanyList = (payload) => {
  return {
    type: MastersActions.SET_COMPANY_LIST,
    payload,
  };
};

// User Master Action (Company Admin Master,Management Master,Vessel Admin Master,Superintendent Master)

export const getUserMasterList = (payload) => {
  return {
    type: MastersActions.GET_USER_MASTER_LIST,
    payload,
  };
};

export const setUserMasterList = (payload) => {
  return {
    type: MastersActions.SET_USER_MASTER_LIST,
    payload,
  };
};

export const addUserMasterList = (payload) => {
  return {
    type: MastersActions.ADD_USER_MASTER,
    payload,
  };
};

export const deleteUserMasterList = (payload) => {
  return {
    type: MastersActions.DELETE_USER_MASTER,
    payload,
  };
};

export const updateUserMasterList = (payload) => {
  return {
    type: MastersActions.UPDATE_USER_MASTER,
    payload,
  };
};

// Department Master Action

export const getDepartmentMasterList = (payload) => {
  return {
    type: MastersActions.GET_DEPARTMENT_MASTER_LIST,
    payload,
  };
};

export const setDepartmentMasterList = (payload) => {
  return {
    type: MastersActions.SET_DEPARTMENT_MASTER_LIST,
    payload,
  };
};

export const updateDepartmentMasterList = (payload) => {
  return {
    type: MastersActions.UPDATE_DEPARTMENT_MASTER,
    payload,
  };
};

export const addNewDepartMent = (payload) => {
  return {
    type: MastersActions.ADD_NEW_DEPARTMENT,
    payload,
  };
};

export const deleteDepartment = (payload) => {
  return {
    type: MastersActions.DELETE_DEPARTMENT,
    payload,
  };
};

// Checklist Question Master Action

export const getChecklistQuestionMasterList = (payload) => {
  return {
    type: MastersActions.GET_QUESTION_CHECKLIST_MASTER_LIST,
    payload,
  };
};

export const setChecklistQuestionMasterList = (payload) => {
  return {
    type: MastersActions.SET_QUESTION_CHECKLIST_MASTER_LIST,
    payload,
  };
};

export const addQuestionMasterList = (payload) => {
  return {
    type: MastersActions.ADD_QUESTION_MASTER,
    payload,
  };
};

export const updateQuestionMasterList = (payload) => {
  return {
    type: MastersActions.UPDATE_QUESTION_MASTER,
    payload,
  };
};

export const deleteQuestionChecklistMasterList = (payload) => {
  return {
    type: MastersActions.DELETE_QUESTION_CHECKLIST_MASTER,
    payload,
  };
};

export const setChecklistQuestionMasterPagination = (payload) => {
  return {
    type: MastersActions.SET_CHECKLIST_QUESTION_MASTER_PAGINATION,
    payload,
  };
};

// Send Notification Master Action

export const getSendNotificationMasterList = (payload) => {
  return {
    type: MastersActions.GET_SEND_NOTIFICATION_MASTER_LIST,
  };
};

export const setSendNotificationMasterList = (payload) => {
  return {
    type: MastersActions.SET_SEND_NOTIFICATION_MASTER_LIST,
    payload,
  };
};

export const addSendNotificationMasterList = (payload) => {
  return {
    type: MastersActions.ADD_SEND_NOTIFICATION_MASTER,
    payload,
  };
};

// Support Master Action

export const getSupportMasterList = (payload) => {
  return {
    type: MastersActions.GET_SUPPORT_MASTER_LIST,
  };
};

export const setSupportMasterList = (payload) => {
  return {
    type: MastersActions.SET_SUPPORT_MASTER_LIST,
    payload,
  };
};

// For open or close model Send Notification master Action

export const setIsOpenModelAddSendNotificationMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_ADD_SEND_NOTIFICATION_MASTER,
    payload,
  };
};

// For open or close model Department master Action

export const setIsOpenModelAddDepartmentMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_ADD_DEPARTMENT_MASTER,
    payload,
  };
};

export const setIsOpenModelEditDepartmentMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_EDIT_DEPARTMENT_MASTER,
    payload,
  };
};

// For open or close model User Master Action (Company Admin Master,Management Master,Vessel Admin Master,Superintendent Master)

export const setIsOpenModelAddUserMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_ADD_USER_MASTER,
    payload,
  };
};

export const setIsOpenModelEditUserMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_EDIT_USER_MASTER,
    payload,
  };
};

// For open or close model Checklist Question master Action

export const setIsOpenModelAddQuestionMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_ADD_QUESTION_MASTER,
    payload,
  };
};

export const setIsOpenModelEditQuestionMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_EDIT_QUESTION_MASTER,
    payload,
  };
};

// For open or close model  Checklist Type master Action

export const setIsOpenModelAddChecklistTypeMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_ADD_CHECKLIST_TYPE_MASTER,
    payload,
  };
};

export const setIsOpenModelEditChecklistTypeMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_EDIT_CHECKLIST_TYPE_MASTER,
    payload,
  };
};

// For open or close model  Vessel Type master Action

export const setIsOpenModelAddVesselTypeMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_ADD_VESSEL_TYPE_MASTER,
    payload,
  };
};

export const setIsOpenModelEditVesselTypeMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_EDIT_VESSEL_TYPE_MASTER,
    payload,
  };
};

// For open or close model Vessel master Action

export const setIsOpenModelAddVesselMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_ADD_VESSEL_MASTER,
    payload,
  };
};

export const setIsOpenModelEditVesselMaster = (payload) => {
  return {
    type: MastersActions.IS_OPEN_MODELS_EDIT_VESSEL_MASTER,
    payload,
  };
};

// For Master Pagination Action

export const setPaginationForMaster = (payload) => {
  return {
    type: MastersActions.SET_PAGINATION_MASTER,
    payload,
  };
};
